import { Route } from 'react-router';
import { QuestDetailsPage, QuestsPage } from '@betty/quests/pages';
import ProtectedRoutes from '../components/ProtectedRoutes';

export const renderQuestsRoutes = () => (
  <Route path="quests" element={<ProtectedRoutes />}>
    <Route index element={<QuestsPage />} />
    <Route path=":id" element={<QuestDetailsPage />} />
  </Route>
);
